export const ru = {
    'event-error-title': 'Событие недоступно',
    'event-error-description': 'События с таким event_id не существует или вас нет в списке участников'
};
